/* eslint-disable no-underscore-dangle */
import { Component, Input, OnInit } from '@angular/core';
import { ModalController, LoadingController } from '@ionic/angular';
import { Bono, Cita, Cliente } from 'src/app/interfaces/interfaces';
import { BonoService } from 'src/app/services/bono.service';
import { BonoConstants } from '../bono/bono.constant';

@Component({
  selector: 'app-modal-gestion-bono',
  templateUrl: './modal-gestion-bono.component.html',
  styleUrls: ['./modal-gestion-bono.component.scss'],
})
export class ModalGestionBonoComponent implements OnInit {

  @Input()
  public bono: Bono;

  @Input()
  public cliente: Cliente;

  @Input()
  public citas: Cita[];

  public nombreBono = '';

  loading: any;

  constructor(private modalCtrl: ModalController,
    private bonoService: BonoService,
    private loadingCntrl: LoadingController) { }

  ngOnInit() {
    this.nombreBono = BonoConstants.cargarNombreBono(this.bono.tipo);
  }

  cerrarModal() {
    this.modalCtrl.dismiss();
  }

  async presentLoading() {
    this.loading = await this.loadingCntrl.create({
      message: 'Cargando'
    });
    return await this.loading.present();
  }

  public addCita(): void {
    if (!this.citas) {
      this.citas = [];
    }
    this.citas.unshift({bono: this.bono._id});
  }

  public eventosDesdeCitas(event) {
    this.bono = event;
  }

}
